import React from 'react';
import styles from './TodayHero.module.css';

const SIZE = 56;
const STROKE = 5;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/** Anel com a fração do dia já realizada. */
function DayProgressRing({ done, total }) {
  const ratio = total ? Math.min(done / total, 1) : 0;

  return (
    <div className={styles.ring} role="img" aria-label={`${done} de ${total} consultas realizadas`}>
      <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
        <defs>
          <linearGradient id="dayProgressGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#5A80FB" />
            <stop offset="100%" stopColor="#8B7CF6" />
          </linearGradient>
        </defs>
        <circle cx={SIZE / 2} cy={SIZE / 2} r={RADIUS} fill="none" stroke="#E6EBFA" strokeWidth={STROKE} />
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          stroke="url(#dayProgressGradient)"
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={CIRCUMFERENCE * (1 - ratio)}
          transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
          className={styles.ringProgress}
        />
      </svg>
      <span className={styles.ringValue}>{Math.round(ratio * 100)}%</span>
    </div>
  );
}

export default DayProgressRing;
